import React from 'react';
import PropTypes from 'prop-types';
import { StackedBarChart } from '../../../../core/components/StackedBarChart';
import { Card } from '../../../../core/components/Card';

function StackedBar({ analytics, sx, title, isLarge }) {
  return (
    <Card
      sx={{
        ...sx,
        maxWidth: 'calc(100% - 415px)',
        width: '100%'
      }}
    >
      <StackedBarChart data={analytics} title={title} isLarge={isLarge} />
    </Card>
  );
}

StackedBar.propTypes = {
  sx: PropTypes.any,
  analytics: PropTypes.any,
  title: PropTypes.string.isRequired,
  isLarge: PropTypes.bool
};

export default StackedBar;
